import { Box, Text } from '@factorialco/deprecated-design-system'
import { Spinner } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

const Syncing = ({ integrationName }: { integrationName: string }) => {
  return (
    <Box
      background="grey200"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{ all: 'abs008' }}
      gap="s16"
    >
      <Box gap="s4" flexDirection="row" alignItems="center">
        <Spinner size="small" />
        <Text.Header2>
          {i18n.t('payroll_integrations.employee_update_leave.syncing.title', {
            integration_name: integrationName,
          })}
        </Text.Header2>
      </Box>
      {i18n.t('payroll_integrations.employee_update_leave.syncing.message', {
        integration_name: integrationName,
      })}
    </Box>
  )
}

export default Syncing
